import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

function Timer ({tooltip})
{
  const { t } = useTranslation();

  const timerRef = useRef(null);

  const navigate = useNavigate();

  const [time, setTime] = useState(undefined);
  const [sKey, setSKey] = useState(1);
  const gameStarted = useSelector((state) => state.game.gameStarted);
  const timeLimit = useSelector((state) => state.game.timeLimit);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {

    const currentUrl = window.location.href;
    let isTimesUpUrl = false;
    if(currentUrl.includes("game/timesup")){
      isTimesUpUrl = true;
    }

    const timer = setInterval(() => {
      if(gameStarted){
        let startTime = new Date(gameStarted);
        let currentTime = new Date();
        let timeDiff = Math.round((currentTime - startTime) / (1000*60));
        let timeLeft = timeLimit - timeDiff;
        if(timeLeft <= 2){
          timerRef.current.classList.add('blink');
          setSKey(sKey + 1);
        }
        if(timeLeft <= 0){
          if(!isTimesUpUrl){
            navigate("/app/game/timesup" + window.location.search);
          }
          timeLeft = 0;
        }
        setTime(timeLeft);
      }
      
    }, 1000);

    if(tooltip){
      setTimeout(() => {
        setShowTooltip(true);
        setTimeout(() => {
          setShowTooltip(false);
        },5000);
      },3000);
    }

    return () => clearInterval(timer);
      
  }, [gameStarted, timeLimit]);
  return (
    <div className="gameTimerWrapper">
      <div className="gameTimer pillSimple" ref={timerRef}>
        <div className="time-icon">
          <div className="indicator"></div>
        </div>
        <span className="time">{time}</span>
        <span className="time-label">min</span>
      </div>
    </div>
  )
}

/*
<div className="timer-icon">
          {sKey && 
             <svg xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" width={20} height={20} viewBox="0 0 20 20">
             <g transform="translate(-207.305 -341.858) translate(217.305 351.858) translate(-10 -10)">
               <clipPath id="_clip1">
                 <path d="M0 0H20V20H0z"></path>
               </clipPath>
               <g clipPath="url(#_clip1)">
                 <circle cx="10" cy="10" r="8.5" fill="none" stroke={`${time <= 2 ? '#FF013E' : '#5DC0F8'}`} strokeWidth="3"></circle>
               </g>
             </g>
             <g transform="translate(-207.305 -341.858) translate(218.305 351.858) translate(-2.5 -5)">
               <clipPath id="_clip2">
                 <path d="M0 0H5V10H0z"></path>
               </clipPath>
               <g clipPath="url(#_clip2)">
                 <path fill="none" fillRule="nonzero" stroke={`${time <= 2 ? '#FF013E' : '#5DC0F8'}`} strokeLinecap="round" strokeWidth="2" d="M1 1v5l2.5 2.5"></path>
               </g>
             </g>
           </svg>
          }
         
        </div>
        <div className="time-left">
          <span className="time">{time}</span>
          <span className="time-label">min</span>
        </div>

        { showTooltip && 
      <div className="timer-tooltip">
        <span>{t("student.timer.tooltip")}</span>
      </div>}

*/

export default Timer;